<template>
  <modal v-if="isShow" class="search-friend-modal">
    <template slot="header">
      <h4 class="modal-title">장학금 매칭</h4>
      <md-button class="md-simple md-just-icon md-round modal-default-button" @click="closed">
        <md-icon>clear</md-icon>
      </md-button>
    </template>
    <template slot="body">
      <div class="md-layout">
        <div class="md-layout-item">
          <table class="flex-table">
            <tr v-show="!isSetTarget">
              <th star>장학대상자</th>
              <td>
                <div class="inline-flex">
                  <input type="text" placeholder="성명" v-model="searchNm" v-on:keyup.enter="searchTarget(null)">
                  <button @click="searchTarget(null)">
                    <md-icon>search</md-icon>
                  </button>
                </div>
              </td>
            </tr>
            <tr v-show="!isSetTarget">
              <th>검색결과<br>[학번,이름,생년월일]</th>
              <td>
                <dl class="list-in-table" v-for="item in mappingTargetList" v-bind:key="item.applySeqNo">
                  <dt>
                    <input type="radio" name="mappingTarget" v-bind:value="item" v-model="mappingTarget" style="align-items: baseline">
                    {{item.hakbun}}, {{item.nm}}, {{item.BornYm}}
                  </dt>
                </dl>
              </td>
            </tr>
            <tr v-show="isSetTarget">
              <th>학번/이름/출생년월</th>
              <td>{{mappingTarget.hakbun}} {{mappingTarget.nm}} {{mappingTarget.BornYm}}</td>
            </tr>
            <tr>
              <th class="letter-dense">대학/학과/학년</th>
              <td>{{mappingTarget.collegeMCdNm}} {{mappingTarget.collegeSCdNm}} </td>
            </tr>
            <tr>
              <th class="letter-dense">대상학기/등록금</th>
              <td>{{mappingTarget.collegeSemesterCdNm}} / {{formatter.getCurrency(mappingTarget.tuitionAmount ? mappingTarget.tuitionAmount : 0)}}원</td>
            </tr>
          </table>
        </div>

        <div class="md-layout-item">
          <table class="flex-table">
            <tr>
              <th>구분</th>
              <td>
                {{applyGbNm[matchingData.applyGb]}}
              </td>
            </tr>
            <tr>
              <th star>定額구분</th>
              <td>
                <label><input type="radio" v-model="matchingData.giveGb" name="giveGb" value="1">전액</label>
                <label><input type="radio" v-model="matchingData.giveGb" name="giveGb" value="2">定額지급</label>
                <label><input type="radio" v-model="matchingData.giveGb" name="giveGb" value="3" disabled>미분류</label>
              </td>
            </tr>
            <tr>
              <th>실입금매핑</th>
              <td>{{matchingData.agreemCount}}</td>
            </tr>
            <tr>
              <th>정액지급액</th>
              <td>{{matchingData.totalAmount}}원</td>
            </tr>
            <tr>
              <th star>장학회</th>
              <td>
                <div class="inline-flex">
                  <select v-model="matchingData.scha2ndInfoGb">
                    <option value="목적사업비">목적사업비</option>
                    <option value="기본재산">기본재산</option>
                  </select>
                  <input type="text" placeholder="금액입력" v-model="matchingData.schaAmount" v-mask="'########'" @keyup="changeTotalAmount">
                </div>
              </td>
            </tr>
            <tr>
              <th star>교우회</th>
              <td>
                <div class="inline-flex">
                  <select v-model="matchingData.kuaa2ndInfoGb">
                    <option value="기부자실입금">기부자실입금</option>
                    <option value="학생직접입금">학생직접입금</option>
                    <option value="연계지급">연계지급</option>
                    <option value="기금">기금</option>
                  </select>
                  <input type="text" placeholder="금액입력" v-model="matchingData.kuaaAmount" v-mask="'########'" @keyup="changeTotalAmount">
                </div>
              </td>
            </tr>
            <tr>
              <th>보전액</th>
              <td>
                <input type="number" placeholder="금액입력" v-model="matchingData.reserveAmount" maxlength="8" @keyup="changeTotalAmount">
              </td>
            </tr>
            <tr>
              <th>비고</th>
              <td>
                <textarea name="" id="" cols="30" rows="10" v-model="matchingData.etc"></textarea>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </template>
    <template slot="footer">
      <md-button class="md-info md-sm" @click="saveMatcing" v-show="!isSetTarget">등록</md-button>
      <md-button class="md-info md-sm" @click="saveMatcing" v-show="isSetTarget">변경</md-button>
      <md-button class="md-info md-sm" @click="deleteMatcing" v-show="isSetTarget">삭제</md-button>
      <md-button class="md-default md-sm" @click="initData">초기화</md-button>
      <md-button class="md-default md-sm" @click="closed">취소</md-button>
    </template>
  </modal>
</template>
<script>
import formatter from "@/kuaa/kuaa-formatter";
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";

import Swal from "sweetalert2";
import moment from "moment";

import {
  Modal,
} from "@/components";

export default {
  name: "DonorMatchingModalComp",

  props: {
    isShow : {
      type: Boolean,
      default: false
    }
  },

  components: {
    Modal
  },

  created() {
  },

  computed: {
  },

  watch : {
    'mappingTarget' (){
      this.matchingData.applyGb = this.mappingTarget.applyGb;
      this.matchingData.applySeqNo = this.mappingTarget.applySeqNo;
      this.matchingData.semesterCd = this.mappingTarget.semesterCd;
      this.matchingData.collegeSemesterCd = this.mappingTarget.collegeSemesterCd;
    }
  },
  data() {
    return {
      formatter,
      searchNm : null,
      isSetTarget : false,
      currentSemesterCd : null,
      currentMemberNo : null,
      applyGbNm : {
        '1' : '개인명의',
        '2' : '교우자녀',
        '3' : '교우회(장학)'
      },
      mappingTargetList : [],
      mappingTarget : {},
      donatorInfo : {},
      matchingRowData : {},
      matchingData : {
        memberNo : null,
        applySeqNo : null,
        semesterCd : null,
        applyGb : null,
        giveGb : null,
        agreemCount : '',
        totalAmount : 0,
        scha2ndInfoGb : null,
        schaAmount : null,
        kuaa2ndInfoGb : null,
        kuaaAmount : null,
        reserveAmount : null,
        etc : null,
        collegeSemesterCd : null
      }
    };
  },
  methods: {
    closed(){
      this.clearMatchingData();
      this.searchNm = null;
      this.isSetTarget = false;
      this.matchingRowData = {};
      this.mappingTarget = {};
      this.mappingTargetList = [];
      this.$emit('update:isShow', false);
    },
    clearMatchingData(){
      this.matchingData = {
        memberNo : null,
        applySeqNo : null,
        semesterCd : null,
        applyGb : null,
        giveGb : null,
        agreemCount : '',
        totalAmount : 0,
        scha2ndInfoGb : null,
        schaAmount : null,
        kuaa2ndInfoGb : null,
        kuaaAmount : null,
        reserveAmount : null,
        etc : null,
        collegeSemesterCd : null
      }
    },
    searchTarget(option){
      let modalOptions = kuaaFnc.getSwalModaloptions();
      let params = {};
      if(option){
        params = option;
      }else{
        if(!this.searchNm || this.searchNm=='' || this.searchNm.length < 2){
          Swal.fire(kuaaFnc.getSwalModaloptions({'html':'장학대상자를 2글자 이상으로 입력 하세요'}));
          return;
        }
        params = {nm: this.searchNm, semesterCd : this.currentSemesterCd, memberNo : this.currentMemberNo};
      }
      kuaaApi.sendServer(
        (option == null) ? URL_CONST.GET_SCHA_MAPPING_RESOURCE : URL_CONST.GET_SCHA_MAPPING_LIST,
        params,
        "post",
        response => {
          if (response.data.result){
            this.mappingTargetList = response.data.data.contents;
            if(option){
              this.mappingTarget = this.mappingTargetList[0];
              this.mappingTarget.tuitionAmount = formatter.getCurrency(this.mappingTarget.tuitionAmount ? this.mappingTarget.tuitionAmount : 0);
            }else{
              this.mappingTarget = {};
            }
          } else {
            modalOptions.html = `회원 정보 조회 실패 하였습니다.`;
            Swal.fire(modalOptions);
          }
        }
      )
    },
    setData (item, donatorInfo){
      this.clearMatchingData();
      this.donatorInfo = donatorInfo;
      this.matchingData.memberNo = donatorInfo.memberNo;

      if(donatorInfo.agreemAmount){
        this.matchingData['agreemCount'] = (parseInt(donatorInfo.agreemAmount) /4000000).toFixed(2) + '구좌 / ' + formatter.getCurrency(donatorInfo.agreemAmount) + '원';
      }else{
        this.matchingData['agreemCount'] = '0구좌 / 0원'
      }

      if(item){
        this.matchingRowData = item;
        this.isSetTarget = true;
        this.matchingData['applyGb'] = item.applyGb;
        this.matchingData['giveGb'] = item.giveGb;
        this.matchingData['scha2ndInfoGb'] = item.scha2ndInfoGb;
        this.matchingData['schaAmount'] = item.schaAmount;
        this.matchingData['kuaa2ndInfoGb'] = item.kuaa2ndInfoGb;
        this.matchingData['kuaaAmount'] = item.kuaaAmount;
        this.matchingData['reserveAmount'] = item.reserveAmount;
        this.matchingData['etc'] = item.etc;
        this.matchingData['applySeqNo'] = item.applySeqNo;
        this.matchingData['memberNo'] = item.memberNo;
        this.matchingData['semesterCd'] = item.semesterCd;
        this.matchingData['collegeSemesterCdNm'] = item.collegeSemesterCdNm;
        this.searchTarget({
          memberNo : item.memberNo,
          semesterCd : item.semesterCd,
          applySeqNo : item.applySeqNo
        });
      }else{
        this.matchingRowData = {};
        this.matchingData['memberNo'] = donatorInfo.memberNo;
        this.matchingData['applyGb'] = null;
        this.matchingData['giveGb'] = null;
        this.matchingData['scha2ndInfoGb'] = null;
        this.matchingData['schaAmount'] = null;
        this.matchingData['kuaa2ndInfoGb'] = null;
        this.matchingData['kuaaAmount'] = null;
        this.matchingData['reserveAmount'] = null;
        this.matchingData['etc'] = null;
        this.matchingData['applySeqNo'] = null;
        this.matchingData['semesterCd'] = this.currentSemesterCd;
        this.isSetTarget = false;
      }
      this.changeTotalAmount();

    },
    changeTotalAmount(){
      this.matchingData.totalAmount = formatter.getCurrency(Number(this.matchingData.schaAmount) + Number(this.matchingData.kuaaAmount) + Number(this.matchingData.reserveAmount));
    },
    saveMatcing(){
      if(!this.matchingData.applySeqNo){
        kuaaFnc.showSwal("장학금 매칭", `대상자를 선택 해 주세요.`);
        return;
      }


      // 등록금 전액 && 등록금과 입력한 금액이 상이한 경우
      if(!this.matchingData.giveGb){
        kuaaFnc.showSwal("장학금 매칭", `정액구분[등록금 전액 / 정액지급]을 선택해 주세요.`);
        return;
      }

      if(!this.matchingData.totalAmount){
        kuaaFnc.showSwal("장학금 매칭", `입력된 장학금이 없습니다.`);
        return;
      }

      if(this.matchingData.schaAmount > 0 && !this.matchingData.scha2ndInfoGb){
        kuaaFnc.showSwal("장학금 매칭", `장학회 구분[장학금]을 선택해 주세요.`);
        return;
      }

      if(this.matchingData.kuaaAmount > 0 && !this.matchingData.kuaa2ndInfoGb){
        kuaaFnc.showSwal("장학금 매칭", `교우회 구분[장학금]을 선택해 주세요.`);
        return;
      }

      // 등록금 전액 && 등록금과 입력한 금액이 상이한 경우
      if(this.matchingData.giveGb == '1' && formatter.getCurrency(this.mappingTarget.tuitionAmount) != formatter.getCurrency(Number(this.matchingData.totalAmount?.replaceAll(',','')))){
         alert(`입력된 장학금(등록금 전액)이 일치하지 않습니다.`);
      }



      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        html: this.isSetTarget ? "장학금을 변경 하시겠습니까?" : "장학금을 등록 하시겠습니까?",
      });

      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          modalOptions = kuaaFnc.getSwalModaloptions();
          kuaaApi.sendServer(
            URL_CONST.SAVE_SCHA_MAPPING,
            this.matchingData,
            "post",
            response => {
              if (response.data.success){
                kuaaFnc.showSwal("장학금 매칭", this.isSetTarget ? `변경 되었습니다.` : `등록 되었습니다.`);
                this.closed();
                this.$emit('saveComplete');
              } else {
                kuaaFnc.showSwal("장학금 매칭", this.isSetTarget ? `변경 실패 하였습니다.` : `등록 실패 하였습니다.`);
                this.closed();
              }
            }
          )
        }
      });
    },
    deleteMatcing(){
      let modalOptions = kuaaFnc.getSwalModaloptions();
      if(!this.matchingData.applySeqNo){
        modalOptions['html'] = '대상자를 선택 해 주세요';
        Swal.fire(modalOptions);
        return;
      }

      modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        html: "삭제 하시겠습니까?",
      });

      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          modalOptions = kuaaFnc.getSwalModaloptions();
          kuaaApi.sendServer(
            URL_CONST.DELETE_SCHA_MAPPING,
            {
              applySeqNo : this.matchingRowData.applySeqNo,
              memberNo : this.matchingRowData.memberNo,
              semesterCd : this.matchingRowData.semesterCd
            },
            "post",
            response => {
              if (response.data.success){
                modalOptions.html = `삭제 되었습니다.`;
                Swal.fire(modalOptions);
                this.closed();
                this.$emit('saveComplete');
              } else {
                modalOptions.html = `삭제 실패 하였습니다.`;
                Swal.fire(modalOptions);
                this.closed();
              }
            }
          )
        }
      });
    },

    initData(){
      let initData = {
        giveGb : null,
        scha2ndInfoGb : null,
        schaAmount : null,
        kuaa2ndInfoGb : null,
        kuaaAmount : null,
        reserveAmount : null,
        totalAmount: 0,
        etc : null
      }
      Object.assign(this.matchingData, initData);
    },

    searchTuition(){
      let modalOptions = kuaaFnc.getSwalModaloptions();
      let params = {};
      if(option){
        params = option;
      }else{
        if(!this.searchNm || this.searchNm=='' || this.searchNm.length < 2){
          Swal.fire(kuaaFnc.getSwalModaloptions({'html':'장학대상자를 2글자 이상으로 입력 하세요'}));
          return;
        }
        params = {nm: this.searchNm, semesterCd : this.currentSemesterCd, memberNo : this.currentMemberNo};
      }
      kuaaApi.sendServer(
          (option == null) ? URL_CONST.GET_SCHA_MAPPING_RESOURCE : URL_CONST.GET_SCHA_MAPPING_LIST,
          params,
          "post",
          response => {
            if (response.data.result){
              this.mappingTargetList = response.data.data.contents;
              if(option){
                this.mappingTarget = this.mappingTargetList[0];
                this.mappingTarget.tuitionAmount = formatter.getCurrency(this.mappingTarget.tuitionAmount ? this.mappingTarget.tuitionAmount : 0);
              }else{
                this.mappingTarget = {};
              }
            } else {
              modalOptions.html = `회원 정보 조회 실패 하였습니다.`;
              Swal.fire(modalOptions);
            }
          }
      )
    }

    // todo 검색기능 구현
    // 검색 후 graduateInfo에 해당 학생 매칭
  }
};
</script>

<style lang="css" scoped>
  .modal-mask {z-index: 100;}
</style>